import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'walkAnimation-action',
    templateUrl:'walkAnimation.html'
})
export class WalkAnimationActionComponent extends BaseActionComponent implements OnInit {

  public itens;
  public linkForm: FormGroup;
  public proximityForm: FormGroup
  public follow=false;
  public index;
  public level=1
  public media;
  public dataList=[];
  public animations=[];
  public showAnimations=false;
  public currentAnimationRef='';
  public easeOptions=[
    {name:'linear',kind:'linear'},
    {name:'suave (easeInOut)',kind:'easeInOut'},
    {name:'entrada (easeIn)',kind:'easeIn'},
    {name:'saída (easeOut)',kind:'easeOut'}
  ];
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.fb.group({
      time:1,
      dx:0,
      dy:0,
      dz:0,
      rx:0,
      ry:0,
      rz:0,
      sx:1,
      sy:1,
      sz:1,
      ease:'linear'
    });
    this.proximityForm = this.fb.group({
      follow:false
    });    
    this.linkForm.valueChanges.subscribe(v=>{
      this.applyFormToFrame();
    });
  }
  /////////////////////////////////////////////////////////////////////
  // LEITURA DO ITEM EM EDICAO
  // Os valores vem de _appData.object, que e o item que o editor esta manipulando
  // no mundo (mesma fonte usada pelo whereIAm() do movableAction).
  /////////////////////////////////////////////////////////////////////
  public itemTransform(){
    let object=this._appData.object;
    if (!object){
      return null;
    }
    let position=object.position ? object.position : {x:0,y:0,z:0};
    let rotation=object.rotation ? object.rotation : {x:0,y:0,z:0};
    let scale=object.scale ? object.scale : {x:1,y:1,z:1};
    return {
      dx: Number(position.x) || 0,
      dy: Number(position.y) || 0,
      dz: Number(position.z) || 0,
      rx: Number(rotation.x) || 0,
      ry: Number(rotation.y) || 0,
      rz: Number(rotation.z) || 0,
      sx: scale.x==0 || scale.x==null ? 1 : Number(scale.x),
      sy: scale.y==0 || scale.y==null ? 1 : Number(scale.y),
      sz: scale.z==0 || scale.z==null ? 1 : Number(scale.z)
    };
  }
  //Botao do keyFrame: coleta posicao/rotacao/escala do item e joga no keyFrame em edicao
  public getPosition(){
    let frame=this.currentFrame();
    if (!frame){
      Swal.fire('Nenhum keyFrame em edicao','Clique em "editar" em um keyFrame (ou crie um com "adicionar") antes de capturar a posicao.');
      return;
    }
    let transform=this.itemTransform();
    if (!transform){
      Swal.fire('Nenhum item em edicao','Selecione um item da sala no editor de objetos para poder capturar posicao, rotacao e escala.');
      return;
    }
    frame.dx=transform.dx;
    frame.dy=transform.dy;
    frame.dz=transform.dz;
    frame.rx=transform.rx;
    frame.ry=transform.ry;
    frame.rz=transform.rz;
    frame.sx=transform.sx;
    frame.sy=transform.sy;
    frame.sz=transform.sz;
    this.syncFormFromFrame(frame);
  }
  /////////////////////////////////////////////////////////////////////
  // KEYFRAMES
  /////////////////////////////////////////////////////////////////////
  public keyFrames(){
    let action=this.currentAction();
    if (!action.param.keyFrames){
      action.param.keyFrames=[];
    }
    return action.param.keyFrames;
  }
  //lista de keyFrames, sempre mantida ordenada por tempo
  public framesList(){
    let frames=this.keyFrames();
    return frames;
  }
  public frameIndex(frame){
    return this.keyFrames().indexOf(frame);
  }
  //mantem o array ordenado por tempo e devolve a nova posicao do keyFrame
  public defaultFrame(){
    let transform=this.itemTransform();
    let frame={
      time:5,
      dx:0,dy:0,dz:0,
      rx:0,ry:0,rz:0,
      sx:1,sy:1,sz:1,
      animation:'',
      ease:'linear'
    };
    if (transform){
      frame.dx=transform.dx;
      frame.dy=transform.dy;
      frame.dz=transform.dz;
      frame.rx=transform.rx;
      frame.ry=transform.ry;
      frame.rz=transform.rz;
      frame.sx=transform.sx;
      frame.sy=transform.sy;
      frame.sz=transform.sz;
    }
    return frame;
  }
  public addData(){
    let frame=this.defaultFrame();
    let frames=this.keyFrames();
    frame.time=1;
    frames.push(frame);
    this.currentAnimationRef=frame.animation ? frame.animation : '';
    this.syncFormFromFrame(frame);
  }
  public duplicateData(frame){
    let copy=JSON.parse(JSON.stringify(frame));
    let frames=this.framesList();
    let idx=frames.indexOf(frame);
    frames.splice(idx+1,0,copy);
    this.index=frames.indexOf(copy);
    this.currentAnimationRef=copy.animation ? copy.animation : '';
    this.syncFormFromFrame(copy);
  }
  public editData(action,i){
    let frames=this.framesList();
    let idx=i;
    if (idx==null || idx==undefined || idx<0){
      idx=frames.indexOf(action);
    }
    this.media=action;
    this.index=idx;
    this.currentAnimationRef=action.animation ? action.animation : '';
    this.syncFormFromFrame(action);
  }
  public removeData(frame,i){
    let selected=this.currentFrame();
    let frames=this.framesList();
    let idx=i;
    if (idx==null || idx==undefined || idx<0){
      idx=frames.indexOf(frame);
    }
    frames.splice(idx,1);
    if (selected===frame){
      this.index=null;
      this.currentAnimationRef='';
    }
    else if (this.index!=null && idx<this.index){
      this.index=this.index-1;
    }
  }
  public moveUp(frame){
    let frames=this.framesList();
    let pos=frames.indexOf(frame);
    if (pos<=0){
      return;
    }
    //troca apenas o tempo com o keyFrame anterior da lista ordenada
    let prev=frames[pos-1];
    let t=Number(frame.time)||0;
    frame.time=Number(prev.time)||0;
    prev.time=t;
    this.index=this.framesList().indexOf(frame);
  }
  public currentFrame(){
    if (this.index==null || this.index==undefined){
      return null;
    }
    return this.keyFrames()[this.index];
  }
  public currentAction(){
    let action = this.level==1 ? this._appData.action : this._appData.secondAction;
    if (!action){
      action={kind:'walkAnimation',param:{}};
      if (this.level==1){
        this._appData.action=action;
      }
      else{
        this._appData.secondAction=action;
      }
    }
    if (!action.param){
      action.param={};
    }
    return action;
  }
  /////////////////////////////////////////////////////////////////////
  // FORM <-> KEYFRAME
  /////////////////////////////////////////////////////////////////////
  public syncFormFromFrame(frame){
    if (!frame){
      return;
    }
    this.linkForm.reset({
      time: frame.time!=null ? frame.time : 1,
      dx: frame.dx!=null ? frame.dx : 0,
      dy: frame.dy!=null ? frame.dy : 0,
      dz: frame.dz!=null ? frame.dz : 0,
      rx: frame.rx!=null ? frame.rx : 0,
      ry: frame.ry!=null ? frame.ry : 0,
      rz: frame.rz!=null ? frame.rz : 0,
      sx: frame.sx!=null ? frame.sx : 1,
      sy: frame.sy!=null ? frame.sy : 1,
      sz: frame.sz!=null ? frame.sz : 1,
      ease: frame.ease ? frame.ease : 'linear'
    },{emitEvent:false});
  }
  public applyFormToFrame(){
    let frame=this.currentFrame();
    if (!frame){
      return;
    }
    let v=this.linkForm['_value'];
    frame.time=Number(v.time)||0;
    frame.dx=Number(v.dx)||0;
    frame.dy=Number(v.dy)||0;
    frame.dz=Number(v.dz)||0;
    frame.rx=Number(v.rx)||0;
    frame.ry=Number(v.ry)||0;
    frame.rz=Number(v.rz)||0;
    frame.sx=v.sx==0 || v.sx==null ? 1 : Number(v.sx);
    frame.sy=v.sy==0 || v.sy==null ? 1 : Number(v.sy);
    frame.sz=v.sz==0 || v.sz==null ? 1 : Number(v.sz);
    frame.ease=v.ease ? v.ease : 'linear';
    //o tempo pode ter mudado: reordena mantendo este keyFrame selecionado
    this.action.param.keyFrames[this.index]=frame;
  }
  /////////////////////////////////////////////////////////////////////
  // ANIMACOES DA SALA (por keyFrame)
  /////////////////////////////////////////////////////////////////////
  public selectAnimation(anim){
    let frame=this.currentFrame();
    if (!frame){
      return;
    }
    frame.animation=this.buildAnimationRef(anim);
    this.currentAnimationRef=frame.animation;
    this.showAnimations=false;
  }
  public clearAnimation(){
    let frame=this.currentFrame();
    if (frame){
      frame.animation='';
    }
    this.currentAnimationRef='';
    this.showAnimations=false;
  }
  public animationName(ref){
    if (!ref){
      return 'nenhuma';
    }
    if (ref.indexOf('http')>=0){
      let parts=ref.split('/');
      return parts[parts.length-1]
    }
    let split=ref.split('-');
    if (split[0]=='pack' && split.length>3){
      let pack=this._appData.room.packs[split[1]];
      if (pack && pack.animation){
        for (let i=0;i<pack.animation.length;i++){
          if (pack.animation[i].id==split[3] || pack.animation[i].transaction==split[3]){
            return pack.animation[i].name ? pack.animation[i].name : ref;
          }
        }
      }
    }
    if (split[0]=='texture' && split.length>1){
      let list=this.roomAnimations();
      for (let i=0;i<list.length;i++){
        let id=list[i].id ? list[i].id : list[i].transaction;
        if (id==split[1]){
          return list[i].name ? list[i].name : ref;
        }
      }
    }
    return ref;
  }
  public buildAnimationRef(anim){
    if (this.selectedPack){
      return 'pack-'+this.selectedPack.id+'-id-'+anim.id;
    }
    return 'texture-'+anim.id;
  }
  public roomAnimations(){
    let list=[];
    if (this.selectedPack && this.selectedPack.animation){
      list=this.selectedPack.animation;
    }
    else{
      if (this._appData.room && this._appData.room.textures && this._appData.room.textures.animation){
        list=this._appData.room.textures.animation;
      }
    }
    return list;
  }
  public reloadLocalPacks(){
    this.animations=[];
    let list=this.roomAnimations();
    list.forEach(ic=>{
      if (!ic.id){ic.id=ic.transaction;}
      this.animations.push(ic);
    })
    this.dataList=[];
    let split=null;
    if (this.currentAnimationRef){
      split=this.currentAnimationRef.split('-');
      if (split.length>0 && split[0]=='pack'){
        this.selectedPack=this._appData.room.packs[split[1]]
      }
    }
  }
  /////////////////////////////////////////////////////////////////////
  // PERSISTENCIA
  /////////////////////////////////////////////////////////////////////
  public processData(action){
    if (!action){
      action={kind:'walkAnimation',param:{}}
    }
    if (!action.param){
      action.param={};
    }
    this.applyFormToFrame();
    //garante a ordem por tempo antes de gravar
    //a animacao agora e por keyFrame (keyFrames[].animation); se o item tiver
    //alguma animacao propria ela vive em item.animate, e nao aqui
    delete action.param.animation;
    action.param.itens=[];
    action.param.follow=this.proximityForm.controls.follow.value;
    if (this._appData.object && this._appData.object.objectId){
      action.param.itens=[this._appData.object.objectId];
    }
  }


    public childrenReloadData() {
      this.itens=[]
      let action=this.currentAction();
      //compatibilidade: versoes antigas guardavam uma animacao unica no param
      let legacyAnimation=action.param && action.param.animation ? action.param.animation : '';
      if (action.param && action.param.keyFrames){
        action.param.keyFrames.forEach(f=>{
          if (f.time==null){f.time=1}
          if (f.sx==null || f.sx==0){f.sx=1}
          if (f.sy==null || f.sy==0){f.sy=1}
          if (f.sz==null || f.sz==0){f.sz=1}
          if (!f.ease){f.ease='linear'}
          if (!f.animation && legacyAnimation){f.animation=legacyAnimation}
        })
        this.itens=action.param.keyFrames
      }
      if (action.param.follow){
            this.proximityForm = this.fb.group({
              follow:true
            });  
            this.follow=true; 
      }
      let frame=this.currentFrame();
      if (frame){
        this.currentAnimationRef=frame.animation ? frame.animation : '';
        this.syncFormFromFrame(frame);
      }
      else{
        this.currentAnimationRef='';
      }
      this.reloadLocalPacks();
    }
    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/walkAnimation.ts